import { type CommonTemplateProps } from '#app/components/Modals/V2/GlobalModalSystem/types.js';
import { ModalTemplateWrapper } from '../ModalTemplateWrapper/ModalTemplateWrapper.js';

type DeleteChatMessageWarningModalProps = CommonTemplateProps & {
  readonly isLoading: boolean;
  readonly onDeleteMessage: () => void;
};

export const DeleteChatMessageWarningModal = ({
  closeModal,
  isLoading,
  isOpen,
  onDeleteMessage,
}: DeleteChatMessageWarningModalProps) => {
  const title = 'Delete this message?';
  const body = 'This message will be permanently deleted and cannot be undone.';

  return (
    <ModalTemplateWrapper
      ariaLabel={title}
      ctaOptions={{
        primaryCTA: {
          handleOnClick: () => {
            onDeleteMessage();
            closeModal();
          },
          isDisabled: isLoading,
          isLoading,
          label: 'Delete message',
          variant: 'V2Destructive',
        },
        secondaryCTA: {
          handleOnClick: closeModal,
          isDisabled: isLoading,
          label: 'Cancel',
        },
      }}
      desktopModalSize="md"
      headerText={title}
      isDismissible={false}
      isFullscreenOnMobile={false}
      isOpen={isOpen}
      onClose={closeModal}
      subheaderText={body}
    />
  );
};
